import { Axios } from 'utils/AxiosConfig'

export const postCalculatePackage = async (payload) => {
  const { data: response } = await Axios.post(`member/package-subscription/calculate`, payload)
  return response
}
export const postSubmitPackages = async (payload) => {
  const { data: response } = await Axios.post(`member/package-subscription`, payload)
  return response
}
export const putPaymentPackageSuccess = async (id) => {
  const { data: response } = await Axios.put(`member/package-subscription/pay/${id}`)
  return response
}
